// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"d73f62a6","453":"e5dfcaf3","777":"ee819e74"}[chunkId] + ".chunk.js";
};